import React, { useState } from 'react';
import skybizLogo from '../../../assets/icon/skybiz.png';
import ProfileDropdown from './ProfileDropdown';
import ReusableSelect from '../Select';
import { ITime } from '../../../type/time';
import useTimeStore from '../../../store/timeStore';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CalenderIcon from '../../../assets/CalenderIcon';
import useBgColorStore from '../../../store/bgColor';
import { RateId } from '../../../constants/constant';
import useLocationStore from '../../../store/locatonStore';
import useDateStore from '../../../store/selectedDateStore';
import {  getAdjustedDate } from '../../../utils/dateUtils';
import WhatsAppIcon from '../../../assets/icon/whatsappIcon';
import CalenderIconDark from '../../../assets/CalenderIconDark';
import { IBookingAvailability } from '../../../type/BookingAvailability';
import Loader from '../../../assets/loader/Loader';
import { useBookingRates } from '../../../hooks/apiHook/operationDetails';

const TopHeader = () => {
  const selectedLocation = useLocationStore((state) => state.selectedLocation);

  const { selectedDateFromStore, setSelectedDateFromStore } = useDateStore();
  const navigate = useNavigate();
  const { operationTime, setOperationTime, setRateId } = useTimeStore();
  const [selectedDate, setSelectedDate] = useState<Date>(
    selectedDateFromStore instanceof Date
      ? selectedDateFromStore
      : selectedDateFromStore
        ? new Date(selectedDateFromStore)
        : getAdjustedDate(),
  );

  const [rateId, setRateIds] = useState<number>(1);
  const [bookingData, setBookingData] = useState<IBookingAvailability | null>(
    null,
  );
  const time: ITime[] = [
    { value: '1h' },
    {
      value: '24h',
    },
    {
      value: '1w',
    },
  ];

  const handleOperationTimeChange = (selectedTime: ITime) => {
    if (selectedTime?.value && selectedTime.value in RateId) {
      setRateId(RateId[selectedTime.value as keyof typeof RateId]);
      setRateIds(RateId[selectedTime.value as keyof typeof RateId]);
    }
    setOperationTime(selectedTime.value);
  };

  const {
    data: bookingRateData,
    isLoading: bookingIsLoading,
    isFetching,
    error,
    refetch: refetchBookingRates,
  } = useBookingRates(selectedDate, selectedLocation?.OwnerId ?? null, rateId);

  useEffect(() => {
    if (bookingRateData) {
      setBookingData(bookingRateData);
    }
  }, [bookingRateData]);

  const fallbackUrl = `https://web.whatsapp.com/`;
  const whatsappUrl = `whatsapp://send`;

  const handleClick = () => {
    const timeout = setTimeout(() => {
      window.open(fallbackUrl, '_blank');
    }, 1500);
    window.location.href = whatsappUrl;
    window.addEventListener('blur', () => clearTimeout(timeout));
  };

  return (
    <div className="flex items-center w-full justify-between  bg-sidebar-background p-3.5 rounded-lg shadow-sm mb-4">
      <div className="flex items-center">
        <img className="w-32" src={skybizLogo} alt="skyBiz logo" />
      </div>
      <div className="flex items-center space-x-4">
        <div className="mr-2">
          <button onClick={handleClick}>
            <WhatsAppIcon width={35} height={35} />
          </button>
        </div>
        <div
          className={`flex items-center space-x-2 rounded border border-customBorder-border h-[38px] px-3  bg-backgroundColor-darkThemeColor`}
        >
          <div
            className="flex items-center space-x-4 cursor-pointer"
            onClick={() => {
              navigate('/calendar');
            }}
          >
            <div>
              <div className="block dark:hidden">
                <CalenderIcon />
              </div>
              <div className="hidden dark:block">
                <CalenderIconDark />
              </div>
            </div>
            {/* <CalenderIcon /> */}
            <span className=" text-textColor">
              {selectedDate?.toDateString()}
            </span>
          </div>

          {bookingIsLoading || isFetching ? (
            <div className="flex justify-center items-center bg-background">
              <Loader />
            </div>
          ) : (
            <div className="flex items-center gap-4 ml-8">
              <span className="text-textColorGray">
                {bookingData?.booked}/{bookingData?.availability}
              </span>
              <span className="text-calenderColor-topHeader">
                {bookingData?.increasedBooking != null &&
                  (bookingData.increasedBooking > 0 ? (
                    <span>+{bookingData.increasedBooking}</span>
                  ) : bookingData.increasedBooking < 0 ? (
                    <span className="text-red-500">
                      {bookingData.increasedBooking}
                    </span>
                  ) : (
                    0
                  ))}
              </span>
            </div>
          )}
        </div>

        <div>
          <div className="">
            <ReusableSelect<ITime>
              options={time}
              className="w-full border rounded p-2 text-sm  bg-backgroundColor-darkThemeColor text-text-secondary border-customBorder-border "
              getOptionLabel={(option: ITime) => option.value}
              getOptionValue={(option: ITime) => option.value}
              onChange={(selectedOption) => {
                handleOperationTimeChange(selectedOption);
              }}
              placeholder="Time"
              value={operationTime}
            />
          </div>
        </div>
        <ProfileDropdown />
      </div>
    </div>
  );
};

export default TopHeader;
